export class FocusTrap {

    static canBeFocused(el) {
        const isFocusableByDefault = el.matches('a[href], button, input, textarea, select, [tabindex]');
        const hasTabIndex = el.tabIndex >= 0;
        const isVisible = !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        const isNotHidden = !el.hasAttribute('hidden') && !el.classList.contains('hidden');
        const isNotDisabled = !el.hasAttribute('disabled');
        const isNotABumper = !el.hasAttribute('data-bumper');
        return (isFocusableByDefault || hasTabIndex) && isVisible && isNotHidden && isNotDisabled && isNotABumper;
    }

    static getFocusableElements(el) {
        const focusableElements = el?.querySelectorAll('audio, button, canvas, details, iframe, [href], input, select, summary, textarea, video, progress, [accesskey], [contenteditable], [tabindex]:not([tabindex="-1"])');
        return [...focusableElements]?.filter(item => FocusTrap.canBeFocused(item));
    }

    static getLastFocusableElement(el) {
        return FocusTrap.getFocusableElements(el)
            ?.reverse()
            ?.find(element => element.tabIndex > -1);
    }

    static getFirstFocusableElement(el) {
        return FocusTrap.getFocusableElements(el)?.find(element => element.tabIndex > -1);
    }

    static buildFocusBumperElements(container) {
        const bumperStart = document.createElement('focus-bumper');
        const bumperEnd = document.createElement('focus-bumper');

        bumperStart.tabIndex = '0';
        bumperStart.dataset.bumper = 'start';
        bumperStart.setAttribute('aria-hidden', 'true');

        bumperEnd.tabIndex = '0';
        bumperEnd.dataset.bumper = 'end';
        bumperEnd.setAttribute('aria-hidden', 'true');

        container.insertAdjacentElement('afterbegin', bumperStart);
        container.insertAdjacentElement('beforeend', bumperEnd);
    }

    static focusTrapHandler(event, container) {
        if (event.target.matches('focus-bumper[data-bumper="start"]')) {
            FocusTrap.getLastFocusableElement(container)?.focus();
        }
        if (event.target.matches('focus-bumper[data-bumper="end"]')) {
            FocusTrap.getFirstFocusableElement(container)?.focus();
        }
    }

    static start(container) {
        FocusTrap.buildFocusBumperElements(container);
        const firstFocusable = FocusTrap.getFirstFocusableElement(container);

        if (!firstFocusable) {
            console.warn('No focusable elements found in the container.');
            return;
        }

        container.querySelectorAll('focus-bumper').forEach(bumper => {
            bumper.addEventListener('focus', event => FocusTrap.focusTrapHandler(event, container));
        });

        firstFocusable.focus();
    }

    static stop(container) {
        container.querySelectorAll('focus-bumper').forEach(bumper => {
            bumper.removeEventListener('focus', FocusTrap.focusTrapHandler);
            bumper.remove();
        });
    }
}

class FocusBumper extends HTMLElement {}
customElements.define('focus-bumper', FocusBumper);

window.FocusTrap = FocusTrap;